<template>
    <v-list
        id="norfield-nav-list-items"
    >
        <v-menu
            v-for="item in items"
            :key="item.title"
            bottom
            dark
            nudge-right="10"
            content-class="nav-bar-menu"
            offset-x
            :disabled="!(navbarMini && item.items.length)"
        >
            <template #activator="{ on: onMenu }">
                <v-tooltip
                    right
                    color="#34383f"
                    :disabled="!navbarMini"
                >
                    <template #activator="{ on: onTooltip }">
                        <div :class="{ 'show-active-bar': isActiveNavListGroup(item.title.toLowerCase()) }">
                            <v-list-group
                                no-action
                                :group="item.title.toLowerCase()"
                                color="#fff"
                                :append-icon="item.items.length ? 'expand_more' : ''"
                                v-on="{ ...onMenu, ...onTooltip }"
                                @click.stop.prevent="gotoListGroupRoute(item.to)"
                            >
                                <v-icon
                                    slot="prependIcon"
                                    class="material-icons-outlined"
                                >
                                    {{ item.icon }}
                                </v-icon>
                                <template
                                    v-slot:activator
                                >
                                    <v-list-item-content>
                                        <v-list-item-title v-text="item.title" />
                                    </v-list-item-content>
                                </template>
                                <v-list-item
                                    v-for="child in item.items"
                                    :key="child.title"
                                    :to="child.to"
                                    @click.native.stop
                                >
                                    <v-list-item-content>
                                        <div class="active-bar" />
                                        <v-list-item-title v-text="child.title" />
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-group>
                            <div class="list-group-active-bar" />
                        </div>
                    </template>
                    <span>{{ item.title }}</span>
                </v-tooltip>
            </template>
            <v-list>
                <v-list-item
                    v-for="child in item.items"
                    :key="child.title"
                    :to="child.to"
                    @click.prevent
                >
                    <div class="active-bar" />
                    <v-list-item-content>
                        <v-list-item-title>{{ child.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
        <v-menu
                bottom
                dark
                nudge-right="10"
                content-class="nav-bar-menu"
                offset-x
                :disabled="!(navbarMini)"
            >
                <template #activator="{ on: onMenu }">
                    <v-tooltip
                        right
                        color="#34383f"
                        :disabled="!navbarMini"
                    >
                        <template #activator="{ on: onTooltip }">
                            <div>
                                <v-list-group
                                    no-action color="#fff"
                                    v-on="{ ...onMenu, ...onTooltip }"
                                    >
                                    <template v-slot:activator>
                                        <v-list-item-content>
                                                <v-list-item-title>
                                                    <v-icon
                                                    slot="prependIcon"
                                                    class="material-icons-outlined" > mdi-message-alert-outline </v-icon>
                                                    <span style="margin-left: 2rem;">Feedback and Help</span></v-list-item-title>
                                            </v-list-item-content>
                                    </template>
                                    <v-list-item @click="openUrlInNewTab('https://locatorlogix.airfocus.site/feedback/ideas')">
                                        <v-list-item-content>
                                            <v-list-item-title>Feedback</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item @click="openUrlInNewTab('https://norfield.freshdesk.com/support/home')">
                                        <v-list-item-content>
                                            <v-list-item-title>Help and Support</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-group>
                                <div class="list-group-active-bar" />
                            </div>
                        </template>
                        <span>Feedback and Help</span>
                    </v-tooltip>
                </template>
                <v-list>
                    <v-list-item @click="openUrlInNewTab('https://locatorlogix.airfocus.site/feedback/ideas')">
                        <v-list-item-content>
                            <v-list-item-title>Feedback</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="openUrlInNewTab('https://norfield.freshdesk.com/support/home')">
                        <v-list-item-content>
                            <v-list-item-title>Help and Support</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu>
    </v-list>
</template>

<script>
import { getNavigationItems } from '../services/navigationRBAC';

export default {
    computed: {
        items() {
            return getNavigationItems(this.user.ingroup || '');
        },
        user() {
            return this.$store.getters.user;
        },
        navbarMini() {
            return this.$store.getters.navbarMini;
        },
    },
    methods: {
        isNavListGroupRoot(path) {
            // If a navigationItem is found with the to value equal to the path
            // then it is NOT a Nav List Group Root.
            return !(this.items.find(nav => nav.to === path) || false);
        },
        isActiveNavListGroup(path) {
            return this.isNavListGroupRoot(path)
                && this.$route.path.includes(path);
        },
        // This function is needed because v-list-group does not support
        // the 'to' navigation property that v-list-item supports.
        gotoListGroupRoute(to) {
            if(to && !this.isActiveNavListGroup(to)) {
                this.$router.push(to);
            }
        },
        openUrlInNewTab(url) {
            window.open(url, '_blank');
        }
    },
};
</script>
<style>
#norfield-nav-list-items .theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled),
#norfield-nav-list-items .theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) i,
#norfield-nav-list-items .theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) .theme--dark.v-icon {
    color: #fff!important;
}
.v-list-item--active .active-bar
 {
    border-radius: 10px;
    width: 4px;
    background-color: #F26227;
    margin-left: 8px;
    height: 20px;
    left: 0px;
    position: absolute;
    clip: auto;
}
/* expanded navdrawer submenu items need their active-bar positioned differently
than those of the pop out menus */
#norfield-nav-list-items .v-list-group__items .v-list-item--active .active-bar {
    margin-left:-8px;
    left:auto;
}
#norfield-nav-list-items .show-active-bar {
    position:relative;
}
#norfield-nav-list-items .show-active-bar .list-group-active-bar
{
    border-radius: 10px;
    width: 4px;
    background-color: #F26227;
    margin-left: 8px;
    height: 20px;
    left: 0px;
    position: absolute;
    top: 18px;
}
#norfield-nav-list-items .v-list-item__title {
    font-size:14px;
}
.nav-bar-menu .theme--dark.v-list{
    background-color: #122448;
}
.v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child){
    margin-left: unset;
}
</style>